import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT, TEXT_ALIGN } from '../../foundations/typography';
import { ButtonSizeType, ButtonVariantType } from '../button/variants';
import { TextVariantType } from '../text/variants';
import { CheckboxVariantType, LinkVariantType } from '../variants';
const commonSwipedCardContainerTabletAndMobileStyles = {
    display: 'flex',
    flex_direction: 'row',
    justify_content: 'flex-end',
    position: 'absolute',
    height: '100%',
    right: '0',
    top: '0',
};
export const commonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    rootContainer: {
        display: 'flex',
        width: '100%',
        ...STATE_TOKENS.rootContainer,
    },
    dataWithoutStateBarContainer: {
        flex_grow: '1',
        ...STATE_TOKENS.dataWithoutStateBarContainer,
    },
    tappableAreaContainer: {
        flex_grow: '1',
        display: 'flex',
        cursor: 'pointer',
        gap: FOUNDATIONS.spacing_250,
        padding: FOUNDATIONS.spacing_250,
        ...STATE_TOKENS.tappableAreaContainer,
    },
    cardContainer: {
        width: '100%',
        [DeviceBreakpointsType.TABLET]: {
            position: 'relative',
            overflow: 'hidden',
            ...STATE_TOKENS.cardContainer?.[DeviceBreakpointsType.TABLET],
        },
        [DeviceBreakpointsType.MOBILE]: {
            position: 'relative',
            overflow: 'hidden',
            ...STATE_TOKENS.cardContainer?.[DeviceBreakpointsType.MOBILE],
        },
        ...STATE_TOKENS.cardContainer,
    },
    card: {
        width: '100%',
        padding: FOUNDATIONS.spacing_250,
        display: 'flex',
        gap: FOUNDATIONS.spacing_250,
        position: 'relative',
        [DeviceBreakpointsType.TABLET]: {
            flex_direction: 'row',
            z_index: 1,
            transition: 'transform 0.3s ease-in-out',
            cursor: 'pointer',
            ...STATE_TOKENS.card?.[DeviceBreakpointsType.TABLET],
        },
        [DeviceBreakpointsType.MOBILE]: {
            flex_direction: 'row',
            z_index: 1,
            transition: 'transform 0.3s ease-in-out',
            cursor: 'pointer',
            ...STATE_TOKENS.card?.[DeviceBreakpointsType.MOBILE],
        },
        ...STATE_TOKENS.card,
    },
    actionsContainer: {
        display: 'flex',
        gap: FOUNDATIONS.spacing_250,
        margin_top: FOUNDATIONS.spacing_250,
        align_items: 'center',
        ...STATE_TOKENS.actionsContainer,
    },
    hiddenActionsContainer: {
        [DeviceBreakpointsType.LARGE_DESKTOP]: {
            display: 'none',
            ...STATE_TOKENS.hiddenActionsContainer?.hover?.[DeviceBreakpointsType.LARGE_DESKTOP],
        },
        [DeviceBreakpointsType.DESKTOP]: {
            display: 'none',
            ...STATE_TOKENS.hiddenActionsContainer?.hover?.[DeviceBreakpointsType.DESKTOP],
        },
        hover: {
            [DeviceBreakpointsType.LARGE_DESKTOP]: {
                display: 'flex',
                padding: FOUNDATIONS.spacing_50,
                gap: FOUNDATIONS.spacing_250,
                ...STATE_TOKENS.hiddenActionsContainer?.hover?.[DeviceBreakpointsType.LARGE_DESKTOP],
            },
            [DeviceBreakpointsType.DESKTOP]: {
                display: 'flex',
                padding: FOUNDATIONS.spacing_50,
                gap: FOUNDATIONS.spacing_250,
                ...STATE_TOKENS.hiddenActionsContainer?.hover?.[DeviceBreakpointsType.DESKTOP],
            },
            ...STATE_TOKENS.hiddenActionsContainer?.hover,
        },
        ...STATE_TOKENS.hiddenActionsContainer,
    },
    swipedCardContainer: {
        [DeviceBreakpointsType.TABLET]: {
            ...commonSwipedCardContainerTabletAndMobileStyles,
            ...STATE_TOKENS.swipedCardContainer?.[DeviceBreakpointsType.TABLET],
        },
        [DeviceBreakpointsType.MOBILE]: {
            ...commonSwipedCardContainerTabletAndMobileStyles,
            ...STATE_TOKENS.swipedCardContainer?.[DeviceBreakpointsType.MOBILE],
        },
    },
    dataContainer: {
        width: '100%',
        display: 'flex',
        flex_direction: 'column',
        ...STATE_TOKENS.dataContainer,
    },
    dateAndHiddenActionsContainer: {
        // container padding + icon size
        height: `calc(${FOUNDATIONS.spacing_50} + ${FOUNDATIONS.size_250})`,
        display: 'flex',
        [DeviceBreakpointsType.LARGE_DESKTOP]: {
            justify_content: 'space-between',
            gap: FOUNDATIONS.spacing_250,
            ...STATE_TOKENS.dateAndHiddenActionsContainer?.[DeviceBreakpointsType.LARGE_DESKTOP],
        },
        [DeviceBreakpointsType.DESKTOP]: {
            justify_content: 'space-between',
            gap: FOUNDATIONS.spacing_250,
            ...STATE_TOKENS.dateAndHiddenActionsContainer?.[DeviceBreakpointsType.DESKTOP],
        },
        ...STATE_TOKENS.dateAndHiddenActionsContainer,
    },
    messageContainer: {
        margin_top: FOUNDATIONS.spacing_150,
        ...STATE_TOKENS.messageContainer,
    },
    // stateBar
    stateBar: {
        width: FOUNDATIONS.size_50,
        border_radius: FOUNDATIONS.radius_300,
        background_color: FOUNDATIONS.color_brand_bg_50,
        ...STATE_TOKENS.stateBar,
    },
    // data
    date: {
        ...commonFontStyles(FOUNDATIONS),
        font_variant: TextVariantType.FONT_PARAGRAPH_500,
        font_weight: FONT_WEIGHT.font_regular,
        ...STATE_TOKENS.date,
    },
    message: {
        ...commonFontStyles(FOUNDATIONS),
        font_variant: TextVariantType.FONT_PARAGRAPH_400,
        color: FOUNDATIONS.color_neutral_font_50,
        ...STATE_TOKENS.message,
    },
    category: {
        ...commonFontStyles(FOUNDATIONS),
        font_variant: TextVariantType.FONT_PARAGRAPH_550,
        ...STATE_TOKENS.category,
    },
    // actions
    primaryButton: {
        variant: ButtonVariantType.PRIMARY,
        size: ButtonSizeType.SMALL,
        ...STATE_TOKENS.primaryButton,
    },
    secondaryButton: {
        variant: ButtonVariantType.SECONDARY,
        size: ButtonSizeType.SMALL,
        ...STATE_TOKENS.secondaryButton,
    },
    link: {
        variant: LinkVariantType.SECONDARY,
        ...STATE_TOKENS.link,
    },
    checkbox: {
        variant: CheckboxVariantType.REGULAR,
        ...STATE_TOKENS.checkbox,
    },
    // hover actions
    leftHiddenAction: {
        ...hoverActionsDesktopStyles(),
        ...STATE_TOKENS.leftHiddenAction,
    },
    rightHiddenAction: {
        ...hoverActionsDesktopStyles(),
        ...STATE_TOKENS.rightHiddenAction,
    },
    // swipedCard
    leftSwipedCardButton: {
        ...hoverActionsStyles(FOUNDATIONS, {
            background_color: FOUNDATIONS.color_comp_content_notifications_swipe_op1_bg,
        }),
        ...STATE_TOKENS.leftSwipedCardButton,
    },
    rightSwipedCardButton: {
        ...hoverActionsStyles(FOUNDATIONS, {
            background_color: FOUNDATIONS.color_comp_content_notifications_swipe_op2_bg,
        }),
        ...STATE_TOKENS.rightSwipedCardButton,
    },
});
const commonFontStyles = (FOUNDATIONS) => ({
    color: FOUNDATIONS.color_neutral_font_100,
    font_weight: FONT_WEIGHT.font_bold,
    text_align: TEXT_ALIGN.left,
});
const hoverActionsStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    text: {
        color: FOUNDATIONS.color_neutral_font_static_white,
        font_weight: FONT_WEIGHT.font_bold,
        font_variant: TextVariantType.FONT_PARAGRAPH_400,
        ...STATE_TOKENS.text,
    },
    icon: {
        width: FOUNDATIONS.size_250,
        height: FOUNDATIONS.size_250,
        color: FOUNDATIONS.color_neutral_icon_static_white,
        ...STATE_TOKENS.icon,
    },
    padding: `0 ${FOUNDATIONS.spacing_250}`,
    display: 'flex',
    flex_direction: 'column',
    align_items: 'center',
    justify_content: 'center',
    max_width: FOUNDATIONS.size_800,
    gap: FOUNDATIONS.spacing_100,
    cursor: 'pointer',
    ...STATE_TOKENS,
});
const hoverActionsDesktopStyles = () => ({
    variant: ButtonVariantType.PRIMARY_GHOST,
    size: ButtonSizeType.EXTRA_SMALL,
});
//# sourceMappingURL=commonStyles.js.map